 /** 商品列表 **/
<template>
  <div style="width: 1200px; margin: auto">

    <!-- 面包屑导航 -->
    <el-breadcrumb class="breakcrumbHeader" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item @click.native="breadcrumbClick(item)" v-for="(item) in breadcrumbList" :key="item.id">{{ item.name }}</el-breadcrumb-item>
    </el-breadcrumb>

    <el-container class="filter_con">
      <el-header class="fisrtNav" :loading="cateLoading">
        <el-row>
          <el-col :span="2">
            <span class="labelTitle" v-if="categorylists.length != 0 ? true : false">分类：</span>
          </el-col>
          <el-col :span="22" class="labelcontent">
            <a class="OneLineDisplay" style="width: 10%; display: inline-block; margin-bottom: 10px;text-align:center;" v-for="(item, index) in categorylists" :key="index" :title="item.name" @click="jump(item.parentBxscId,item.bxscId,item.level,item)">{{ item.name }}
            </a>
          </el-col>
        </el-row>
      </el-header>
      <el-container>
        <el-aside width="200px">
          <!-- 热卖商品 -->
          <hotGoods :navTitle="hotGoodsTitle" :hotGoodsList="lefthotGoodsList" :supplieStore='0'></hotGoods>
        </el-aside>
        <el-main class="rightaside">
          <div class="orderby">
            <!-- 筛选项：热销、价格、上新 -->
            <ul>
              <li :class="filterObj.selectTag[0]" @click="clickFilter(true,0,false,'saleNum')">
                <a data-pjax="#page-container" href="javascript:;" rel="nofollow">热销</a>
              </li>
              <!-- 升序 -->
              <li :class="filterObj.selectTag[1]" v-if="formInline.sortway" @click="clickFilter(true,1,false,'price')">
                <a data-pjax="#page-container" href="javascript:;" rel="nofollow">价格
                  <i class="el-icon-arrow-up"></i>
                </a>
              </li>
              <!-- 降序 -->
              <li :class="filterObj.selectTag[1]" v-if="!formInline.sortway" @click="clickFilter(true,1,true,'price')">
                <a data-pjax="#page-container" href="javascript:;" rel="nofollow">价格
                  <i class="el-icon-arrow-down"></i>
                </a>
              </li>
              <li :class="filterObj.selectTag[2]" @click="clickFilter(true,2,false,'createTime')">
                <a data-pjax="#page-container" href="javascript:;" rel="nofollow">上新时间</a>
              </li>
            </ul>
          </div>
          <el-row class="right_product" :gutter="20" v-loading="loading" v-if="rightGoodsList.length>0">
            <!-- 右侧所有商品 -->
            <el-col class="bg_goods_body" v-for="(item, index) in rightGoodsList" :key="index" :span="6">
              <!-- 活动角标区域 -->
              <img v-if="item.bxyMarketing!=null&&item.bxyMarketing.activityTypeId!=7&&item.bxyMarketing.activityTypeId!=8 &&item.bxyMarketing.activityTypeId!=10" class="bg_icon" :src="require('@/assets/images/activity_icon/'+item.bxyMarketing.activityTypeId+'.png')">
              <div class="product_item selectItemCss_ls">
                <div class="p-img">
                  <router-link :to="`/goodsdetail?id=${item.id}`" target="_blank" class="item_link">
                    <img v-lazy="item.photos" alt="" class="img-responsive">
                  </router-link>
                </div>
                <div class="pro_name" @click="looksku(item)">
                  <p class="goodsName">
                    {{ item.name }}
                  </p>
                  <div class="salemsg">
                    <p class="salePrice">
                      <i>¥</i>
                      <!-- // member_price  非0   member_price
                      // 等于0     marketprice  
                     // 等于null   marketprice  
                     // 等于""    marketprice  
                     // 等于-1    面议    -->
                      <!-- <span class="priceText">{{(item.member_price!=null && item.member_price!="") ? item.member_price!=-1 ? item.member_price :
                        '面议' : item.marketprice}}</span> -->
                      <span class="priceText">
                        {{item.newPrice||'面议'}}
                      </span>
                    </p>
                    <p class="saleNum">
                      <span v-if="item.newFlag" class="new_tag">上新</span>{{ item.saleNum ? `已售${item.saleNum}件` : "" }}</p>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="24" class="pagination">
              <Pagination v-bind:child-msg="formInline" @callFather="callFather"></Pagination>
            </el-col>
          </el-row>
          <el-row style="background:#F5F5F5">
            <div class="nodate" v-if="rightGoodsList.length==0">
              <myloading v-if="isRorate" way="1"></myloading>
              <div v-if="!isRorate">
                <!-- 没有商品 -->
                <img :src="require('@/assets/img/noresult.png')">
                <div class="first" style="margin-top:20px;">{{$t('goods.Sorry, there are no products under the corresponding product category or filter combination!')}}</div>
              </div>
            </div>
          </el-row>
        </el-main>
      </el-container>
    </el-container>

    <!-- 加入购物车弹框 -->
    <el-dialog class="addCartBox" :visible.sync="centerDialogVisible" width="30%" center>
      <div style="text-align: center" v-show="successInfo">
        <div class="addGoodsInfo">{{$t('goods.Has been successfully added to the shopping cart!')}}</div>
        <div>{{ addGoodsName }}</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">{{$t('goods.continue shopping')}}</el-button>
          <el-button type="primary" @click="$router.push('/shoppingcart')">{{$t('goods.Go to the shopping cart to checkout')}}</el-button>
        </span>
      </div>
      <div style="text-align: center" v-show="!successInfo">
        <div>{{$t('goods.login required')}}</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="centerDialogVisible = false">{{$t('goods.Sure')}}</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import hotGoods from "@/components/hotGoods";
import myloading from "@/components/myloading";
import "@/assets/css/base.css";
import {
  commoditylist,
  addShoppingCart,
  categorylist,
  shoppingCartlist,
  commoditylistForSecondCategory,
  brandListApi,
  getAttributelist,
  getSpecificationDetail,
  getCalssGoods
} from "@/api/xunyou";
import Pagination from "@/components/Pagination";
import bus from "@/utils/bus"; //引入事件中心
// import '@/assets/xunyou/css/layui.css'
// import '@/assets/bootstrap.min.csss'
export default {
  inject: ["backTop"],
  data() {
    return {
      cateLoading: false,
      isPrompt: false, //是否提示
      isRorate: true,
      brandList: [], //分类下品牌
      breadcrumbList: [
        {
          bxscId: "-1",
          parentBxscId: "-1",
          level: "-1",
          name: "所有分类",
          url: "/goodsList?page=home"
        }
      ], //面包屑数组
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      brandId: "",
      loading: false,
      centerDialogVisible: false,
      successInfo: true,
      categorylists: [], //所有分类
      addGoodsName: "",
      checked1: "",
      checked2: "",
      rightGoodsList: [],
      hotGoodsTitle: "热卖商品",
      isClickCate: false, //是否点击了分类查询
      // 查询条件是否选中
      priceSort: true,
      pariceSort: "asc",
      lefthotGoodsList: [],
      asc: 1, //1.价格升序 0.
      filterObj: {
        selectTag: ["", "", "active"],
        selectTagIdItem: 2, //筛选项默认选中的索引
        filterUpdate: false //是否启用筛选条件
      },
      // 请求数据参数-----热卖商品
      formInline: {
        cid: "",
        stype: 2, // 1.供货商2.普通
        sortway: false, //true-升序，false-降序
        sortname: "createTime", //排序方式
        name: "", //关键字
        pageSize: 20, //每页显示的数量
        pageNum: 1, //当前第几页
        total: 0, //总数总数
        cidLevel: "" //分类等级
      },
      routeQuery: {}, //当前路由的参数
      adWord: "", //关键字
      crumbsList: [] //面包屑列表
      //   items: [
      //     { types: "text", type: "info", label: "热销" },
      //     { types: "text", type: "info", label: "价格" },
      //     { types: "text", type: "info", label: "人气" },
      //     { types: "sort", type: "info", label: "上新" },
      //     { types: "checked", type: "info", label: "仅显示特惠商品" },},
      //     { types: "checked", type: "info", label: "仅显示有货商品" },
      //   ],
    };
  },
  // 注册组件
  components: { hotGoods, Pagination, myloading },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.init();
  },
  watch: {
    $route: {
      handler(newval, oldval) {
        // console.log(newval,'newval');//新路由信息
        // console.log(oldval,'oldval');//老路由信息
        if (oldval.fullPath != newval.fullPath) {
          this.formInline.pageNum = 1;
          this.init();
        }
      },
      // 深度观察监听
      deep: true
    }
  },
  /**
   * 里面的方法只有被调用才会执行里面的方法只有被调用才会执行
   */
  methods: {
    looksku(item) {
      let route = this.$router.resolve({
        path: "/goodsdetail",
        query: {
          id: item.id
        }
      });
      window.open(route.href, "_blank");
    },
    clickFilter(filterUpdate, selectTagIdItem, sortway, sortname) {
      //filterUpdate-是否启用筛选条件。selectTagIdItem-筛选项默认选中的索引。sortway-//true-升序，false-降序。sortname-排序方式
      this.filterObj.selectTag = ["", "", ""];
      this.filterObj.selectTag[selectTagIdItem] = "active";
      this.filterObj.selectTagIdItem = selectTagIdItem;
      this.filterObj.filterUpdate = filterUpdate;
      this.formInline.sortway = sortway;
      this.formInline.sortname = sortname;
      this.formInline.pageNum = 1;
      this.getCommoditylist(this.routeQuery.bxscId, this.routeQuery.adWord); //获取所有商品
    },
    jump(parentBxscId, bxscId, level, item) {
      // console.log(item,'item--');
      if (this.isPrompt) {
        this.$message({
          message: "亲，请耐心等待，正在努力加载中...",
          type: "warning",
          duration: 2000
        });
        return "请不要频繁点击，正在加载中...";
      }
      this.$router.push({
        path: "/goodsList",
        query: { page: "home", parentBxscId, bxscId, level }
      });
    },
    async getCrumbsData() {
      //获取面包屑导航
      this.breadcrumbList = [
        {
          bxscId: "-1",
          parentBxscId: "-1",
          level: "-1",
          name: "所有分类",
          url: "/goodsList?page=home"
        }
      ]; //原始数据
      this.crumbsList = [];
      if (this.routeQuery.level == "1") {
        //当前是一级分类
        await categorylist({
          parentBxscId: "0"
        })
          .then(res => {
            res.forEach((item, index) => {
              if (item.bxscId == this.routeQuery.bxscId) {
                this.crumbsList[0] = {
                  page: "home",
                  bxscId: item.bxscId,
                  parentBxscId: item.parentBxscId,
                  level: item.level,
                  name: item.name,
                  url: `goodsList?page=home&parentBxscId=${
                    item.parentBxscId
                  }&bxscId=${item.bxscId}&level=${item.level}`
                };
              }
            });
          })
          .catch(err => {
            // this.$message.error(err)
            console.log(err);
          });
      } else if (this.routeQuery.level == "2") {
        //当前是二级分类
        //查一级
        await categorylist({
          parentBxscId: "0"
        })
          .then(res => {
            res.forEach((item, index) => {
              if (item.bxscId == this.routeQuery.parentBxscId) {
                this.crumbsList[0] = {
                  page: "home",
                  bxscId: item.bxscId,
                  parentBxscId: item.parentBxscId,
                  level: item.level,
                  name: item.name,
                  url: `goodsList?page=home&parentBxscId=${
                    item.parentBxscId
                  }&bxscId=${item.bxscId}&level=${item.level}`
                };
              }
            });
          })
          .catch(err => {
            // this.$message.error(err)
            console.log(err);
          });
        //--------------------------  //查二级
        await categorylist({
          parentBxscId: this.routeQuery.parentBxscId
        })
          .then(res => {
            res.forEach((item, index) => {
              if (item.bxscId == this.routeQuery.bxscId) {
                this.crumbsList[1] = {
                  page: "home",
                  bxscId: item.bxscId,
                  parentBxscId: item.parentBxscId,
                  level: item.level,
                  name: item.name,
                  url: `goodsList?page=home&parentBxscId=${
                    item.parentBxscId
                  }&bxscId=${item.bxscId}&level=${item.level}`
                };
              }
            });
          })
          .catch(err => {
            // this.$message.error(err)
            console.log(err);
          });
      } else if (this.routeQuery.level == "3") {
        let oneBxscText = ""; //一级分类文本
        let oneBxscId = ""; //一级分类Id
        //---------------获取到三级
        await categorylist({
          parentBxscId: this.routeQuery.parentBxscId
        })
          .then(res => {
            oneBxscText = res[0].typeName;
            res.forEach((item, index) => {
              if (item.bxscId == this.routeQuery.bxscId) {
                this.crumbsList[2] = {
                  page: "home",
                  bxscId: item.bxscId,
                  parentBxscId: item.parentBxscId,
                  level: item.level,
                  name: item.name,
                  url: `goodsList?page=home&parentBxscId=${
                    item.parentBxscId
                  }&bxscId=${item.bxscId}&level=${item.level}`
                };
              }
            });
          })
          .catch(err => {
            // this.$message.error(err)
            console.log(err);
          });
        //获取到一级
        await categorylist({
          parentBxscId: "0"
        })
          .then(res => {
            res.forEach((item, index) => {
              if (item.name == oneBxscText) {
                oneBxscId = item.bxscId; //一级分类id
                this.crumbsList[0] = {
                  page: "home",
                  bxscId: item.bxscId,
                  parentBxscId: item.parentBxscId,
                  level: item.level,
                  name: item.name,
                  url: `goodsList?page=home&parentBxscId=${
                    item.parentBxscId
                  }&bxscId=${item.bxscId}&level=${item.level}`
                };
              }
            });
          })
          .catch(err => {
            // this.$message.error(err)
            console.log(err);
          });
        //获取到二级
        await categorylist({
          parentBxscId: oneBxscId
        })
          .then(res => {
            // console.log(res, '2-第一级----');
            res.forEach((item, index) => {
              if (item.bxscId == this.routeQuery.parentBxscId) {
                this.crumbsList[1] = {
                  page: "home",
                  bxscId: item.bxscId,
                  parentBxscId: item.parentBxscId,
                  level: item.level,
                  name: item.name,
                  url: `goodsList?page=home&parentBxscId=${
                    item.parentBxscId
                  }&bxscId=${item.bxscId}&level=${item.level}`
                };
              }
            });
          })
          .catch(err => {
            // this.$message.error(err)
            console.log(err);
          });
      }
      this.breadcrumbList = [...this.breadcrumbList, ...this.crumbsList];
      // console.log(this.breadcrumbList, "this.breadcrumbList----面包屑导航------");
    },
    init() {
      this.routeQuery = this.$route.query;
      this.filterObj.filterUpdate = false; //重置筛选条件
      if (this.routeQuery.adWord == undefined) {
        //关键字
        this.routeQuery.adWord = "";
      }
      if (this.routeQuery.bxscId == undefined) {
        //当前分类id
        this.routeQuery.bxscId = "";
      }
      //品牌id
      if (this.routeQuery.bxscId) {
        //有具体的分类
        if (this.routeQuery.level == "3") {
          this.getCategorylist(this.routeQuery.parentBxscId); //获取所有的商品分类
        } else {
          this.getCategorylist(this.routeQuery.bxscId); //获取所有的商品分类
        }
      } else {
        //查询全部商品或只根据关键字查询
        this.getCategorylist(0); //获取所有的商品分类
      }
      this.getCommoditylist(this.routeQuery.bxscId, this.routeQuery.adWord); //获取所有商品
      this.getCommodityHotlist(this.routeQuery.bxscId, this.routeQuery.adWord); //获取热卖商品列表获取热卖商品列表
      this.getCrumbsData();
    },
    // 商品分类
    getCategorylist(id) {
      this.cateLoading = true;
      categorylist({
        parentBxscId: id //父类的分类id查找下面的子分类
      })
        .then(res => {
          this.cateLoading = false;
          if (res.length < 1) {
            this.categorylists = [];
            return false;
          }
          this.categorylists = res;
        })
        .catch(err => {
          this.cateLoading = false;
          console.log(err);
        });
    },
    // 商品列表查询
    getCommoditylist(id, adWord) {
      // console.log(this.$route.query,"route");
      this.isRorate = true;
      this.loading = true;
      this.rightGoodsList = []; //清空
      if (this.routeQuery.level) {
        this.formInline.cidLevel = this.routeQuery.level;
      } else {
        this.formInline.cidLevel = "";
      }
      if (this.$route.query.page == "home") {
        //所有商品
        delete this.formInline.newFlag;
        delete this.formInline.clearFlag;
      } else if (this.$route.query.page == "hot") {
        //热销
        delete this.formInline.newFlag;
        delete this.formInline.clearFlag;
        this.formInline.sortname = "saleNum";
      } else if (this.$route.query.page == "clear") {
        //清仓
        delete this.formInline.newFlag;
        this.formInline.clearFlag = true;
      } else {
        //新品
        this.formInline.newFlag = true;
        delete this.formInline.clearFlag;
      }
      this.formInline.cid = id;
      this.formInline.name = adWord;
      this.formInline.brandId = this.brandId;
      this.formInline.userId = this.userInfo.userId || "";
      this.isPrompt = true;
      if (!this.filterObj.filterUpdate) {
        //不启用筛选条件不启用筛选条件
        if (this.$route.query.page == "newFlag" || !this.$route.query.page) {
          this.filterObj.selectTag = ["", "", ""];
          this.filterObj.selectTag[2] = "active";
          this.filterObj.selectTagIdItem = 2;
          this.formInline.sortway = false;
          this.formInline.sortname = "createTime";
        } else {
          this.filterObj.selectTag = ["", "", ""];
          this.filterObj.selectTag[0] = "active";
          this.filterObj.selectTagIdItem = 0;
          this.formInline.sortway = false;
          this.formInline.sortname = "saleNum";
        }
      }
      if (id) {
        // console.log(id,"查找某一类产品");
        getCalssGoods(this.formInline)
          .then(res => {
            if (res.code == "0") {
              this.loading = false;
              this.isPrompt = false;
              this.rightGoodsList = res.rows;
              if (this.$route.query.page == "hot") {
                //热销
                if (res.total >= 200) {
                  this.formInline.total = 200;
                }
              } else {
                this.formInline.total = res.total;
              }
              this.isRorate = false;
            } else {
              this.loading = false;
              this.isPrompt = false;
              this.isRorate = false;
            }
          })
          .catch(err => {
            this.isPrompt = false;
            this.loading = false;
            this.isRorate = false;
            // this.$message.error(err);
            console.log(err);
          });
      } else {
        //查找所有产品
        commoditylist(this.formInline)
          .then(res => {
            if (res.code == "0") {
              this.loading = false;
              this.isPrompt = false;
              this.rightGoodsList = res.rows;
              if (this.$route.query.page == "hot") {
                //热销
                if (res.total >= 200) {
                  this.formInline.total = 200;
                }
              } else {
                this.formInline.total = res.total;
              }
              this.isRorate = false;
            } else {
              this.loading = false;
              this.isPrompt = false;
              this.isRorate = false;
            }
          })
          .catch(err => {
            this.isPrompt = false;
            this.loading = false;
            this.isRorate = false;
            // this.$message.error(this.$t('goods.Failed to query the product list, please try again later!'));
            console.log(err);
          });
      }
    },
    //获取热卖商品列表
    getCommodityHotlist(id, adWord) {
      this.lefthotGoodsList = []; //清空
      this.loading = true;
      var params = JSON.parse(JSON.stringify(this.formInline));
      params.sortname = "saleNum";
      params.cid = id;
      params.name = adWord;
      params.brandId = this.brandId;
      params.sortway = false; //降序
      if (this.routeQuery.bxscId) {
        commoditylistForSecondCategory(params)
          .then(res => {
            this.loading = false;
            this.lefthotGoodsList =
              res.rows.length > 5 ? res.rows.slice(0, 5) : res.rows;
          })
          .catch(err => {
            this.loading = false;
            // this.$message.error(this.$t('goods.Failed to query the product list, please try again later!'));
            console.log(err);
          });
      } else {
        commoditylist(params)
          .then(res => {
            this.loading = false;
            this.lefthotGoodsList =
              res.rows.length > 6 ? res.rows.slice(0, 6) : res.rows;
          })
          .catch(err => {
            this.loading = false;
            // this.$message.error(this.$t('goods.Failed to query the product list, please try again later!'));
            console.log(err);
          });
      }
    },
    // 品牌查询
    /**
     * bXyBid:分类ID
     */
    searchBrand(bXyBid) {
      this.brandList = [];
      this.loading = true;
      brandListApi({ bXyBid: bXyBid }).then(res => {
        if (res.code == 0) {
          // console.log(res.data, "所有品牌分类------");
          res.data.forEach(item => {
            if (null != item.brandList && item.brandList.length != 0) {
              item.brandList.forEach(b => {
                this.brandList.push(b);
              });
            }
          });
        }
      });
    },
    // 显示特惠商品
    showLowGoods() {
      if (this.checked1) {
        this.checked2 = false;
        this.rightGoodsList = [];
        this.formInline.total = 0;
      } else {
        this.getCommoditylist(
          this.$route.query.parentBxscId || -1,
          this.$route.query.adWord
        );
      }
    },
    // 仅显示有货商品
    showHaveGoodList() {
      if (this.checked2) {
        this.checked1 = false;
        this.getCommoditylist(
          this.$route.query.parentBxscId || -1,
          this.$route.query.adWord
        );
      }
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.pageNum;
      this.formInline.pageSize = parm.pageSize;
      this.backTop();
      this.getCommoditylist(this.routeQuery.bxscId, this.routeQuery.adWord);
    },
    // 面包屑点击事件
    breadcrumbClick(item) {
      // console.log(item, 'item');
      this.$router.push({ path: item.url });
    },
    // 获取购物车
    getshoppingCartlist() {
      shoppingCartlist({
        uid: this.userInfo.userId || "",
        userToken: this.userInfo.userToken || ""
      })
        .then(res => {
          if (res.code == "0") {
            this.$store.commit("getCartList", res.data);
          } else {
            if (res.code == "2001") {
              localStorage.removeItem("userdata");
              this.$router.push("/login");
            }
            this.$message({
              message: res.msg,
              type: "warning",
              duration: 2000
            });
          }
        })
        .catch(err => {
          // this.$message.error(this.$t('goods.Shopping cart query failed, please try again later!'));
          console.log(err);
        });
    },
    async addCart(id, name, specificationlist, status, approvalStatus) {
      if (this.userInfo.userId == undefined) {
        this.$message.error(this.$t("goods.please sign in!"));
        setTimeout(() => {
          this.$router.push("/login");
        }, 2000);
        return;
      }
      if (status == 1 && approvalStatus == 1) {
        let attributelis = await getAttributelist({ productId: id });
        let bxysid = attributelis.rows[0].bXyAttributeList[0].id;

        let specificationDetail = await getSpecificationDetail({
          productId: id,
          specificationIds: bxysid,
          userId: this.userInfo.userId || 0
        });
        if (specificationDetail.rows[0].stock - 0 == 0) {
          this.$message.info("添加购物车失败，该商品暂时缺货");
          return;
        }

        let bxyIdNotKnow = specificationDetail.rows[0].id;

        addShoppingCart({
          platform: "pc",
          cid: id,
          uid: this.userInfo.userId,
          number: 1,
          bxysid: 0,
          userToken: this.userInfo.userToken || ""
          // bxysid:specificationlist.length>0?specificationlist[0].bXySid:0
        })
          .then(res => {
            if (res.code == 0) {
              this.addGoodsName = name;
              this.centerDialogVisible = true;
              this.getshoppingCartlist();
            } else {
              if (res.code == "2001") {
                localStorage.removeItem("userdata");
                this.$router.push("/login");
              }
              this.$message({
                message: res.msg,
                type: "warning",
                duration: 2000
              });
            }
          })
          .catch(err => {
            this.loading = false;
            // this.$message.error(this.$t('goods.Failed to add cart, please try again later!'));
            console.log(err);
          });
      } else {
        this.$message.error(this.$t("goods.Temporarily out of stock"));
        return;
      }
    }
  }
};
</script>

<style scoped lang='less'>
/**活动商品角标 */

.new_tag {
  height: 20px;
  width: 40px;
  line-height: 20px;
  background: rgb(51, 112, 255);
  color: #fff;
  display: inline-block;
  text-align: center;
  margin-right: 8px;
}

.bg_goods_body {
  position: relative;
}

img.bg_icon {
  position: absolute;
  width: 150px;
  height: 150px;
  z-index: 12;
  left: 7px;
  top: -3px;
}

/deep/ .el-breadcrumb {
  margin: 15px 0;
  .el-breadcrumb__inner:hover {
    color: #e4393c;
    cursor: pointer;
  }
}

.labelTitle {
  text-align: left;
  padding-left: 15px;
  font-weight: bold;
  color: #333;
  font-size: 14px;
}

.labelcontent {
}

.fisrtNav {
  padding: 10px 0px;
  border-top: 1px dashed #ddd;
  border-bottom: 1px dashed #ddd;
  margin-bottom: 20px;
}

.leftaside {
  /* background: pink; */
  /* padding: 10px; */
  box-sizing: border-box;
  font-size: 14px;
  border: 1px solid #ddd;
  margin-right: 10px;
}

.leftaside h4 {
  padding: 10px;
  border-bottom: 1px solid #ddd;
}

.left_product {
  padding: 10px;
}

.left_product li {
  margin-bottom: 30px;
}

.pro-price {
  margin: 10px 0;
  color: #e4393c;
}

.pro_name {
  font-size: 14px;
  .goodsName {
    padding: 4px 0;
    height: 38px;
    line-height: 20px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .salemsg {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .salePrice {
      color: #ea0a2a;
      .priceText {
        font-size: 16px;
      }
    }
    .saleNum {
      color: #888;
      font-size: 12px;
      letter-spacing: 1px;
    }
  }
}

/* .pro_name {
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 14px;
    margin: 10px 0;
    height: 40px;
    display: flex;
    justify-content: space-between;

  }

  .pro_name a {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 10px;
  } */

.img-responsive {
  width: 200px;
  height: 200px;
  object-fit: cover;
}

.rightaside {
  /* background: yellow; */
  padding: 0px;
  box-sizing: border-box;
  overflow: hidden;
}

.el-header {
  height: auto !important;
}

/* 右边 */

.orderby {
  width: 100%;
  padding: 8px 0;
  background: #f1f1f1;
}

.orderby ul {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.orderby ul li {
  background: #fff;
  color: #333;
  margin-left: 10px;
  border: 1px solid #ddd;
  font-size: 12px;
  padding: 2px 15px;
  line-height: 20px;
}

.active {
  background: #ea0a2a !important;
  font-weight: bold;
}

.active a {
  color: white !important;
}

.orderby .el-checkbox__label {
  font-size: 12px !important;
}

.orderby .el-checkbox__input {
  vertical-align: bottom !important;
}

.right_product {
  padding: 20px;
  min-height: 600px;
}

.right_product .product_item {
  margin-bottom: 20px;
  border: 1px solid #e9e9e9;
  border-color: #e9e9e9;
  -webkit-box-shadow: 0 0 2px 2px #f8f8f8;
  box-shadow: 0 0 2px 2px #f8f8f8;
  padding: 10px;
  box-sizing: border-box;
}

.product_item:hover img {
  opacity: 0.7;
}

.pro_price_add {
  display: flex;
  justify-content: space-around;
}

.cart.add-to-cart,
div.now_price {
  flex: 1;
  font-weight: bold;
  border: 1px solid #f12b2d;
  padding: 8px 0;
  text-align: center;
}

/* .cart.add-to-cart:hover{
	border: 1px solid #f12b2d;
} */

div.now_price {
  color: white;
  background: #f12b2d;
  border: 1px solid #f12b2d;
}

.dialog-footer {
  margin-top: 20px;
  display: block;
}

.addGoodsInfo {
  font-size: 24px;
}

.addCartBox .el-button--primary {
  color: #fff;
  background-color: #ff6700;
  border-color: #e65d00;
}

.more_filter {
  width: 100%;
  text-align: center;
  border-top: 1px dashed #ddd;
  margin-top: -1px;
}

.more_filter:hover {
  border-color: #e13c41;
}

.more_filter span {
  display: inline-block;
  height: 30px;
  line-height: 26px;
  margin-top: -1px;
  width: 130px;
  text-align: center;
  border-width: 1px;
  border-style: dashed;
  border-color: #fff #ddd #ddd;
  background: #fff;
  font-size: 12px;
  color: #939393;
  cursor: pointer;
}

.filter_con {
  padding-bottom: 20px;
}

.filter_con .more_filter span i {
  font-size: 12px;
}

.filter_con .more_filter:hover span {
  color: #e13c41;
  border-color: #fff #e13c41 #e13c41;
}

.nodate {
  text-align: center;
  margin: 200px 0;
  font-size: 16px;
}

.nodate .first {
  margin: 40upx 0 12upx;
  font-size: 28upx;
  color: rgb(210, 210, 210);
}

.pagination {
  text-align: right;
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #ff6700;
    color: #fff;
    width: 20px;
  }
  /deep/.el-pagination.is-background .btn-next,
  /deep/.el-pagination.is-background .btn-prev,
  /deep/.el-pagination.is-background .el-pager li {
    width: 20px;
  }
  /deep/input[disabled],
  input[disabled="disabled"],
  input[readonly],
  input[readonly="readonly"] {
    background-color: transparent;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/goodsList/index_copy.vue